export const PWD_REGEX = /^(?=.*[0-9])(?=.*?[A-Z])(?=.*?[a-z])(?=.*[^A-Za-z0-9])[a-zA-Z0-9]|[^A-Za-z0-9]{8,}$/;
export const S3KEY_REGEX = /\/([^/]+\/[^/?]+)(?=\?)/;
export const TRAILING_SLASHES_REGEX = /\/+$/; // Matches one or more trailing slashes at the end of a path
export const TAN_FEE_MAX_AMOUNT = 10 ** 9; // Max input number value for min amoun on tan fee
export const HEADER_AND_NAVBAR_CONTENT_HEIGHT_PX = 250;
export const DEFAULT_INTERNAL_ERROR_MESSAGE =
    'Something went wrong on our side. Please try again or contact support if the issue persists.';
export const AIS_MAX_ITEMS_PER_DECLARATION = 150;
